import React, { Component } from "react";
import { graphql } from "react-apollo";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { Scrollbars } from "react-custom-scrollbars";
import moment from "moment";
import { CaseHistoryStore, CommonStore, GetCurrentFilter } from "Store";
import { queryGetCasesClosedPagination } from "Apollo";
import LoadingPanel from "module-common/LoadingPanel";
import Row from "module-case-management/list-panel/list/Row";
import styled from "styled-components";

const ListGraphql = graphql(queryGetCasesClosedPagination)(
  observer(
    class ListView extends Component {
      states = observable({ loadingPagination: false, hasReachEnd: false });

      render() {
        const loadingPagination = this.states.loadingPagination
        const paging = (<PagingPanel>
          {!this.states.loadingPagination && (
            <PagingButton 
              onClick={ev => this.onEndReached()} 
              className={this.states.loadingPagination ? 'loading' : ''}
            >
              {this.states.hasReachEnd ? 'You have reached the end of the streams!' : 'Load more'}
            </PagingButton>
          )}            
          {this.states.loadingPagination && <LoadingPanel />}
        </PagingPanel>)


        return (
          <Scrollbars
            ref={ref => (this.scroller = ref)}
            onScrollFrame={() => {}}
          >
            {this.renderRows()}
            {paging}
          </Scrollbars>
        );
      }

      renderRows = () => {
        const store = CaseHistoryStore;
        const {
          data: { getCasesClosedPagination: cases, loading }
        } = this.props;

        // show loading on data fetch
        if (loading) return <LoadingPanel />;

        // render
        const rows = [];
        for (const edge of cases.edges) {
          const row = edge.node;
          
          // label preparation
          const labels = [];
          for (const label of row.labels) {
            if (label.labelTemplate.isShown) {
              labels.push({
                label: label.labelTemplate.displayName,
                value: label.labelTemplate,
                color: "#" + label.labelTemplate.color
              });
            }
          }
          // sort by order and date
          labels.sort((a, b) => {
            if (a.value.order !== b.value.order) {
              return a.value.order > b.value.order;
            } else {
              return moment(a.value.dateCreated).isAfter(b.value.dateCreated);
            }
          });

          rows.push({
            key: row.id,
            id: row.id,
            selected: store.selectedCase && store.selectedCase.id === row.id,
            name: row.customerChannelHandler.name,
            channelName: row.customerChannelHandler.displayName,
            channel: row.channel.name,
            summary: row.lastStream && row.lastStream.content,
            avatar: row.customerChannelHandler.displayPicture,
            timestamp: moment(row.dateUpdated),
            serverTime: CommonStore.serverTime,
            labels: labels,
            onClick: () => (store.selectedCase = row)
          });
        }

        // sorting case
        if (store.sortAsc) {
          rows.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
        } else {
          rows.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
        }

        // render
        const renders = [];
        for (const row of rows) {
          renders.push(<Row {...row} />);
        }
        return renders;
      };

      onScrollFrame = event => {
        // detect if on bottom scroll
        if (event.top === 1) {
          this.onEndReached();
        }
      };

      onEndReached = async () => {
        const {
          data: { fetchMore, getCasesClosedPagination: cases }
        } = this.props;

        // make sure we are not on top most data
        if (cases && cases.edges.length > 0) {
          if (!this.states.loadingPagination) {
            this.states.loadingPagination = true;
            const length = cases.edges.length;
            const cursor = cases.edges[length - 1].cursor;

            await fetchMore({
              variables: {
                after: cursor
              },
              updateQuery: (prevResult, { fetchMoreResult }) => {
                if (!fetchMoreResult) return prevResult;
                const result = Object.assign(
                  {},
                  prevResult.getCasesClosedPagination,
                  {
                    edges: [
                      ...prevResult.getCasesClosedPagination.edges,
                      ...fetchMoreResult.getCasesClosedPagination.edges
                    ]
                  }
                );
                if(!fetchMoreResult.getCasesClosedPagination.edges.length) {
                  this.states.hasReachEnd = true
                } else {
                  this.states.hasReachEnd = false
                }
                return { getCasesClosedPagination: result };
              }
            });
            this.states.loadingPagination = false;
          }
        }
      };
    }
  )
);

export default observer(
  class List extends Component {
    render() {
      return <ListGraphql {...GetCurrentFilter(true)} />;
    }
  }
);


const PagingPanel = styled.div`
  position: relative;
  height: 30px;  
  display: flex;
  flex-direction: column;
`

const PagingButton = styled.div`
  position: relative;
  flex: none;
  align-items: center;
  height: 30px;
  padding-top: 5px;  
  cursor: pointer;
  transition: 0.3s;
  text-align: center;
  border-bottom: 1px solid ${props => props.theme.panelBorder};
  &:hover, &.loading {
    background-color: ${props => props.theme.moduleBackground};    
  }
  &.loading {
    cursor: default;  
  }
  ${props => props.color && `background-color: ${props.theme[props.color]};`};
  ${props =>
    props.selected && `background-color: ${props.theme.moduleBackground};`};
`;




// WEBPACK FOOTER //
// ./src/module-case-history/list-panel/ListWithStoreQuery.js